// src/components/wallet/WalletConnectButton.js
import React from 'react';
import { walletConnect } from '../../web3/connectors';

export default function WalletConnectButton() {
  const handleConnect = async () => {
    if (!walletConnect) {
      console.warn('WalletConnect connector not configured');
      return;
    }
    try {
      await walletConnect.activate(); // ← активация напрямую
    } catch (error) {
      console.error('WalletConnect connection error:', error);
      if (error.code !== 4001) {
        alert('Failed to connect WalletConnect. Please try again.');
      }
    }
  };

  return (
    <button className="connect-banner-action" onClick={handleConnect}>
      Connect Wallet
    </button>
  );
}